import { type FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { countryOptions } from "@/shared/utils/countries";

interface CountryCodeFieldProps {
  label: string;
  value: string[];
  fullWidth?: boolean;
  onChange: (countryCodes: string[]) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

// Переиспользует существующий полный список ISO-кодов стран кабинета
// (countryOptions из @/shared/utils/countries — уже используется в
// countryAccesses/platformPages/userSettings формах), а не заводит новый
// дубликат специально под фильтр аналитики.
export const CountryCodeField: FC<CountryCodeFieldProps> = ({
  label,
  value,
  onChange,
  disabled,
  error,
  helperText,
}) => (
  <Autocomplete
    multiple
    fullWidth
    disabled={disabled}
    options={countryOptions}
    getOptionLabel={(option) => option.label}
    isOptionEqualToValue={(option, selected) => option.value === selected.value}
    value={countryOptions.filter((option) => value.includes(option.value))}
    onChange={(_event, newValue) =>
      onChange(newValue.map((option) => option.value))
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        error={error}
        helperText={helperText}
      />
    )}
  />
);
